export default {
      id: "calendar-usage",
      viewBox: "0 0 15.16 15.5",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#calendar",
      toString: function () {
        return this.url;
      }
    }